export const navbarContents = [
	{ to: '/admin/practice', text: 'Admin Practice', isAdminRoute: true },
	{ to: '/practice', text: 'Practice' },
	// { to: '/intela', text: 'InteLa™' },
	{ to: '/resources', text: 'Resources' },
	{ to: '/pricing', text: 'Pricing' },
	{ to: '/about', text: 'About' },
	{ to: '/contact', text: 'Contact' }
];
